export default __webpack_public_path__ + "static/media/logo-ghost-icon.1bbce069.svg";